"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayProp = void 0;

var util_1 = require("../util");
/**
 * Allows any array. No further runtime validation is performed by default.
 *
 * Type parameter `T` can be used to restrict the type of the array items at compile time.
 *
 *  @param validator - Optional function for further runtime validation; should return `undefined` if valid, or an error string if invalid.
 */


var arrayProp = function arrayProp(validator) {
  return (0, util_1.propOptionsGenerator)(Array, validator);
};

exports.arrayProp = arrayProp;